module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.d8de505.ttf";